import React from 'react';

import { Checkbox } from 'antd';
import styled from 'styled-components';

import Avatar from 'common/Avatar';

import { User } from './types';
import { ACTOR_TYPE } from '../../../constants';

const Container = styled.div`
  display: flex;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 5px;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CheckBox = styled(Checkbox)`
  margin-bottom: 10px;
`;
const Paragraph = styled.p`
  margin-bottom: 0px;
`;

const Text = styled.span`
  color: var(--gray-dark);
  margin-left: 5px;
`;

interface Props {
  user: User;
  checked?: boolean;
  handleChange: (id: number) => void;
}

const ShareViaEmailUsers = ({ user, checked = false, handleChange }: Props) => {
  return (
    <Container>
      <CheckBox checked={checked} onChange={() => handleChange(user?.id)}>
        <FlexContainer>
          <Avatar size={20} name={user.name} type={ACTOR_TYPE.USER} src={user.avatar} color={user.color} />
          <span>{user.name}</span>
          <Paragraph>
            <Text> {user.email}</Text>
          </Paragraph>
        </FlexContainer>
      </CheckBox>
    </Container>
  );
};

export default ShareViaEmailUsers;
